import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import notFoundIcon from '../../../../../assets/images/warranty-not-found-icon.png';

const WarrantyInfoNotFound = ({ serial }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['container']}>
      <img src={notFoundIcon} alt="warranty-not-found" className={styles['icon']} />
      <div className={styles['title']}>{t('warrantyLookup.notFoundTitle')}</div>
      <div className={styles['description']}>
        <Trans i18nKey="warrantyLookup.notFoundDescription" values={{ serial }} components={{ bold: <strong /> }} />
      </div>
      <div className={styles['hint']}>{t('warrantyLookup.notFoundHint')}</div>
    </div>
  );
};

export default WarrantyInfoNotFound;
